<div fxLayout="row" fxFlex="auto" fxLayout.lt-lg="column">
  <div fxLayout="column" fxFlex="auto">

    <div fxLayout="row" fxLayoutAlign="center center">
      @if (!!selfReports && selfReports.length > 0) {
<button nz-button (click)="goForth()" class="prev-sr-btn" [disabled]="
      !selfReports ||
      selfReports.length < 2 ||
      getSelectedIndex() === selfReports.length - 1
    ">
          &lt;
        </button>
      }

      <div class="selected-date" (mousedown)="startDrag($event)" (mousemove)="onDrag($event)"
        (mouseup)="endDrag($event)">
        {{ formatSelectedDate() }}
      </div>

      @if (!!selfReports && selfReports.length > 0) {
        <button nz-button (click)="goBack()" class="next-sr-btn"
          [disabled]="!selfReports || getSelectedIndex() === 0">
          >
        </button>
      }
    </div>

    <div fxLayout="row" fxLayoutAlign="center center">
      <app-body-highlighter [side]="bodySide" [frontSelectedParts]="selectedFrontBodyParts"
        [backSelectedParts]="selectedBackBodyParts">
      </app-body-highlighter>
    </div>
  </div>

  <div fxLayout="column" fxFlex="auto">
    <div fxLayout="row">
      <nz-layout>
        <nz-header class="table-header">
          @if (selfReports?.length! > 0 || isLoading) {
            <div class="table-header-row margin-lr">
              <div class="table-header-cell">
                {{ "Self Report" | translate }}
              </div>
            </div>
          }

          @if (!(selfReports?.length! > 0)) {
            <div fxLayout="row" class="table-header-row">
              @if (!isLoading) {
                <div fxLayout="col" class="title">
                  {{ "Self Report" | translate }} - {{ "No data available" | translate }}
                </div>
              }
            </div>
          }
        </nz-header>

        @if (selfReports?.length! > 0 || isLoading) {
          <nz-content>
            <nz-table #nzTable nzTableLayout="fixed" nzShowTitle="false" nzSize="middle"
              nzNoResult="No Self Report data found" [nzLoading]="isLoading" [nzData]="selfReports || []"
              [nzShowPagination]="true" [nzShowSizeChanger]="true" nzPaginationType="default"
              [nzFrontPagination]="true" [(nzPageIndex)]="currentPageIndex"
              (nzPageIndexChange)="handlePageIndexChange($event)"
              (nzPageSizeChange)="handlePageSizeChange($event)" [nzPageSizeOptions]="[5, 10, 20]"
              [nzPageSize]="pageSize">
              <thead>
                <tr>
                  @for (
                    col of [
                    'Date & Time', 'Front Body Parts' , 'Back Body Parts','Description', 'Level', 'Medication Frequency', 'Medication Timing', 'Symptoms'
                    ]
                    ; track
                    col) {
                    <th>
                      {{ col | translate }}
                      <app-tooltip [fieldName]="col" area="Self Report" />
                    </th>
                  }
                </tr>
              </thead>
              <tbody>
                @for (item of getData(); track item) {
                  <tr [ngClass]="{'selected-sr': selectedSelfReportId === item.id}" class="rows-sr"
                    (click)="changeView(item.id)">
                    @for (
                      field of [
                      'creationDateTime', 'front', 'back', 'description', 'painLevelName', 'medicationFrequencyName', 'timeOfDayValues', 'symptomsValues'
                      ]
                      ; track
                      field) {
                      @if (getValue(field, item[field]?.toString()); as value) {
                        <td [ngClass]="!field.toLocaleLowerCase().includes('datetime') ? 'sr-cell' : ''"
                          nz-tooltip="{{ value }}">
                        {{ value }}</td>
                      }
                    }
                  </tr>
                }
              </tbody>
            </nz-table>
          </nz-content>
        }
      </nz-layout>
    </div>

  </div>

</div>




<!-- (partClicked)="onPartClicked($event)" -->
<!-- <button (click)="bodySide = bodySide === 'front' ? 'back' : 'front'">
Flip Side
</button> -->

<!-- <div fxLayout="row">
<ng-container>
  <app-reusable-table title="Self Reports"
    [columns]="['Date & Time', 'Front Body Parts' , 'Back Body Parts','Description', 'Level', 'Medication Frequency', 'Medication Timing', 'Symptoms']"
    [rowFields]="['creationDateTime', 'front', 'back', 'description', 'painLevelName', 'medicationFrequencyName', 'timeOfDayValues', 'symptomsValues']"
    [data]="selfReports" [isLoading]="isLoading" [isPreview]="true" [pagination]="true" />
  </ng-container>
</div> -->